import { Pressable, StyleSheet, View } from "react-native";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import Icon from "react-native-vector-icons/MaterialIcons";
import { PlaceColors } from "../../genericPages/helpers/PlaceColors";
import { BasePage } from "../../genericPages/helpers/BasePage";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { FindifyDataContext } from "@/contexts/FindifyDataContext";
import { PlaceText } from "../../genericPages/components/PlaceText";

export const ScanTab = ({ navigation }: any) => {
    const insets = useSafeAreaInsets();
    const { t } = useTranslation();
    const findifyDataContext = useContext(FindifyDataContext);
    return (<BasePage navigation={navigation}>
        {/* <FindifyTopBarOverlay /> */}
        <View style={[styles.container, {
            backgroundColor: PlaceColors(findifyDataContext).background.get(), 
        }]} >
            <Pressable style={[styles.button, {
                paddingTop: insets.top,
                backgroundColor: PlaceColors(findifyDataContext).text.withAlpha(30)
            }]} onPress={() => navigation.push('ScanQR')}>
                <View style={[styles.roundedButton, { borderColor: PlaceColors(findifyDataContext).primary.get(), backgroundColor: PlaceColors(findifyDataContext).primary.withAlpha(160), }]}>
                    <Icon style={[styles.roundedButtonIcon, { color: PlaceColors(findifyDataContext).text.get() }]} size={100} name="qr-code" />
                </View>
                <PlaceText style={[styles.buttonText, { color: PlaceColors(findifyDataContext).text.get() }]}>{t('scan_tab.read_qr')}</PlaceText>
            </Pressable>
            <Pressable style={[styles.button, {
                paddingBottom: insets.bottom + 40
            }]} onPress={() => navigation.push('ScanRA')}>
                <View style={[styles.roundedButton, { borderColor: PlaceColors(findifyDataContext).primary.get(), backgroundColor: PlaceColors(findifyDataContext).primary.withAlpha(160), }]}>
                    <Icon style={[styles.roundedButtonIcon, { color: PlaceColors(findifyDataContext).text.get() }]} size={100} name="center-focus-weak" />
                </View>
                <PlaceText style={[styles.buttonText, { color: PlaceColors(findifyDataContext).text.get() }]}>{t('scan_tab.read_ar')}</PlaceText>
            </Pressable>
        </View>
    </BasePage>);
};

const styles = StyleSheet.create({
    container: {
        display: 'flex',
        width: '100%',
        height: '100%',
        justifyContent: 'center',
        alignItems: 'center',
    },
    button: {
        flex: 1,
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        // backgroundColor: 'white'
    },
    buttonText: {
        fontSize: 16,
        paddingTop: 10,
        fontWeight: 'bold',
        // color: '#00000080',
    },
    roundedButtonIcon: {

    },
    roundedButton: {
        width: 150,
        height: 150,
        borderRadius: 150,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderWidth: 2,
    },
})
